export default {
    name: "Serene Manor AFH",
    logo: "/assets/images/serene_manor_logo_wide.png",
    landingImage:{
        imageOld: "/assets/images/mt-ranier.jpg",
        image: "/assets/images/back_of_home_wide_banner.jpeg",
        title: "Serene Manor AFH",
        slogan: "Compassionate care. Joyful living.",
        alt: "A view of the beautiful backyard at Serene Manor Adult Family Home.",
        text: "We are an adult family home in Lacey, Washington, dedicated to providing personalized and dignified care in a safe, nurturing environment."
    },
    mission: {
        title: "OUR MISSION",
        text: "At Serene Manor AFH, our mission is to create a true home for adults in the Lacey community. We are dedicated to providing a safe, warm, and supportive environment where every resident is treated with respect and feels like part of our family. Our caring team offers personalized assistance with daily tasks, engaging activities, and a high level of professional care to ensure not only their well-being but a genuine sense of belonging and joy."
    },
    aboutUs: {
        metaDescription: "Learn about Serene Manor, a premier Adult Family Home providing compassionate, professional care. Discover our mission and meet the team dedicated to your loved ones.",
        title: "ABOUT US",
        text: "Welcome to Serene Manor AFH, your trusted adult family home right here in the heart of Lacey, Washington. Our journey began with a simple but profound belief: that every person deserves to live in an environment that feels like a real home, filled with warmth, respect, and compassion. We’ve built our home on this foundation, create a place where personalized care is the standard, and every resident is a cherished member of our family. Our commitment is to provide a safe, nurturing, and joyful place where individuals can truly thrive.\nOur Philosophy of Care\nOur dedicated team is the heart of our home. Each member is chosen for their professional expertise, but more importantly, for their unwavering commitment to excellence. We work closely with each resident and their family to develop a care plan that respects their unique needs and preferences. From personalized assistance with daily tasks to engaging activities and delicious home-cooked meals, we are passionate about enhancing the quality of life for every person who walks through our doors. We take pride in delivering compassionate care that allows our residents to live with dignity and confidence."
    },
    serviceTitle: "OUR SERVICES",
    imageSlideShow: [
        {
            original: "/assets/images/serene_manor_front_of_house.png",
            thumbnail: "/assets/images/serene_manor_front_of_house_sm.png",
            alt: "Front view of the Serene Manor Adult Family Home"
        },
        {
            original: "/assets/images/serene_manor_entrance.png",
            thumbnail: "/assets/images/serene_manor_entrance_sm.png",
            alt: "Welcoming entrance to Serene Manor"
        },
        {
            original: "/assets/images/serene_manor_living_room.png",
            thumbnail: "/assets/images/serene_manor_living_room_sm.png",
            alt: "Cozy and bright living room for residents"
        },
        {
            original: "/assets/images/serene_manor_kitchen.png",
            thumbnail: "/assets/images/serene_manor_kitchen_sm.png",
            alt: "Modern and clean kitchen area"
        },
        {
            original: "/assets/images/back_of_home_wide.jpeg",
            thumbnail: "/assets/images/back_of_home_wide_sm.jpeg",
            alt: "Spacious backyard and patio area"
        },
        {
            original: "/assets/images/serene_manor_outside.png",
            thumbnail: "/assets/images/serene_manor_outside_sm.png",
            alt: "Outdoor seating area for residents to enjoy"
        },
    ],
    serviceCards: [
        {
            title: "Nurse Care",
            text: "With expert nursing oversight, our team provides professional medical support that brings peace of mind to both residents and their families. This includes comprehensive medication management, vigilant monitoring of health conditions, and seamless coordination with physicians and other healthcare providers. We ensure that every resident's health needs are met with the highest standards of care, right here in the comfort of our home."
        },
        {
            title: "Personal Care",
            text: "Personal Care is designed to provide respectful and dignified assistance with the activities of daily living. Our caregivers are here to support residents with tasks such as bathing, dressing, grooming, and mobility, always prioritizing their comfort and privacy. We understand that personal care needs are unique, and our approach is tailored to help each individual maintain their independence and personal routine, fostering a sense of confidence and well-being."
        },
        {
            title: "Activities",
            text: "We believe in nurturing the mind, body, and spirit through a variety of social, recreational, and creative opportunities. From lively group games and arts and crafts to gentle exercise and social gatherings, our calendar is filled with events designed to foster friendships, stimulate cognitive function, and bring joy to every day. We encourage residents to share their interests and passions, everyone has a chance to connect and have fun."
        },
        {
            title: "24/7 Care",
            text: "Peace of mind is paramount, which is why we provide dedicated 24/7 Care. Our compassionate and trained staff is on-site at all times, day and night, ensuring that help is always just a moment away. This continuous presence provides a secure and safe environment, offering immediate assistance with any needs or emergencies. Families can rest easy knowing their loved one is never alone and is always in the care of a supportive and vigilant team."
        }
    ],
    sideBySideContent: [
        {
            title: "Some Title",
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
            image: "/assets/images/headshot-img.png",
            isImageOnTheLeft: true
        },
        {
            title: "Some Title",
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
            image: "/assets/images/headshot-img.png",
            isImageOnTheLeft: false
        }
    ],
    contactDetails: {
        title: "CONTACT DETAILS", 
        phone: "+1 360-915-8552",
        fax: "+1 360-628-8554",
        email: "serene.manor24@gmail.com",
        address: "3467 Stanfield Rd SE, Lacey, WA 98503",
        addressLink: "https://maps.app.goo.gl/b8m3vc2dadA5WYbdA"
    },
    footer: {
        text: "Copyright 2025 | Designed by Kode Rush",
        socials: [
            {
                icon: "facebook",
                link: "https://www.facebook.com/"
            },
            {
                icon: "twitter",
                link: "https://www.twitter.com/"
            },
            {
                icon: "instagram",
                link: "https://www.instagram.com/"
            },
            {
                icon: "linkedin",
                link: "https://www.linkedin.com/"
            },
            {
                icon: "youtube",
                link: "https://www.youtube.com/"
            }
        ]
    }
}